// extracted by mini-css-extract-plugin
export default {"textProduct":"text_textProduct__XDA8U"};